import * as THREE from "three";

const getUVByPosition = (position, context) => {
  return new THREE.Vector2(
    position.x * context.canvas.width + 1,
    position.y * context.canvas.height + 1
  );
};

const getColorByUV = (uv, context) => {
  const imageData = context.getImageData(
    context.canvas.width - uv.x,
    context.canvas.height - uv.y,
    1,
    1
  );
  const color = imageData.data; // [r, g, b, a]
  return color;
};

const setVertexPositionByColor = (position, context) => {
  const color = getColorByUV(getUVByPosition(position, context), context);
  const boundaryShape = color[0] != color[1] ? 0 : 0.0125;
  return (color[0] / 255) * 0.04 + boundaryShape;
};

export { getUVByPosition, getColorByUV, setVertexPositionByColor };
